'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var WS = require('libp2p-websockets');
var WebRTCStar = require('libp2p-webrtc-star');
var Multiplex = require('libp2p-mplex');
var libp2pNoise = require('@chainsafe/libp2p-noise');
var KadDHT = require('libp2p-kad-dht');
var GossipSub = require('libp2p-gossipsub');
var ipns = require('./utils/ipns.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var WS__default = /*#__PURE__*/_interopDefaultLegacy(WS);
var WebRTCStar__default = /*#__PURE__*/_interopDefaultLegacy(WebRTCStar);
var Multiplex__default = /*#__PURE__*/_interopDefaultLegacy(Multiplex);
var KadDHT__default = /*#__PURE__*/_interopDefaultLegacy(KadDHT);
var GossipSub__default = /*#__PURE__*/_interopDefaultLegacy(GossipSub);

function libp2pConfig() {
  const options = {
    dialer: {
      maxParallelDials: 150,
      maxDialsPerPeer: 4,
      dialTimeout: 10000
    },
    modules: {
      transport: [
        WS__default["default"],
        WebRTCStar__default["default"]
      ],
      streamMuxer: [Multiplex__default["default"]],
      connEncryption: [libp2pNoise.NOISE],
      peerDiscovery: [],
      dht: KadDHT__default["default"],
      pubsub: GossipSub__default["default"]
    },
    config: {
      peerDiscovery: {
        autoDial: true,
        bootstrap: { enabled: true },
        webRTCStar: { enabled: true }
      },
      dht: {
        kBucketSize: 20,
        enabled: true,
        clientMode: true,
        validators: { ipns: ipns.validator },
        selectors: { ipns: ipns.selector }
      },
      pubsub: {
        enabled: true,
        emitSelf: true
      },
      nat: { enabled: false }
    },
    metrics: { enabled: true },
    peerStore: { persistence: true }
  };
  return options;
}

exports.libp2pConfig = libp2pConfig;
